<template>
  <div class="rb-view">
    <RouterView></RouterView>
  </div>
</template>

<style scoped>
/* Pass-through de workspace (Service Desk, AI Agents, CRM): ocupa toda a largura
   disponível para que o conteúdo acompanhe a expansão do main ao minimizar a
   sidebar.

   `height: 100%` não é enfeite: este div fica ENTRE o container de rolagem e a
   página, e sem altura definida ele quebra a cadeia de porcentagem. Quem usa
   `min-height: 100%` lá dentro — o mapa é o caso — passa a medir contra um pai
   de altura automática, a porcentagem é ignorada e a tela encolhe até o piso
   em pixels. Aqui o div reproduz o bloco que a página tinha antes de existir o
   nível extra: o próprio .app-shell__scroll, que é 100%.

   Conteúdo mais alto que isto continua rolando: o scroll é do pai, e o que
   transborda daqui entra na área rolável dele. */
.rb-view {
  width: 100%;
  height: 100%;
}
</style>
